<template>
  <footer class="flex justify-center items-center text-gray-350 mt-4 sm:mt-0">
    <span
      >created by <span class="underline">rxmii4269</span> -
      <a
        href="https://devchallenges.io"
        target="_blank"
        rel="noopener noreferrer"
        >devChallenges.io</a
      ></span
    >
  </footer>
</template>
<script>
export default {
  name: 'Footer',
};
</script>
